import React from 'react';
import ReactDOM from 'react-dom';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faPhoneSlash } from '@fortawesome/free-solid-svg-icons';

const formatPhone = (p) => {
  const digits = String(p || '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  return digits.length === 10 ? `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}` : (p || 'Unknown number');
};

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(22, 163, 74, 0.5); }
  70% { box-shadow: 0 0 0 14px rgba(22, 163, 74, 0); }
  100% { box-shadow: 0 0 0 0 rgba(22, 163, 74, 0); }
`;

const Card = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 2000;
  width: 340px;
  max-width: calc(100vw - 32px);
  background: #111;
  color: #fff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const Ring = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #16a34a;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  animation: ${pulse} 1.4s infinite;
`;

const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #a3a3a3;
`;

const Name = styled.div`
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
`;

const CallerNumber = styled.div`
  font-size: 13px;
  color: #d4d4d4;
`;

const Actions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

const ActionButton = styled.button`
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  background: ${(p) => (p.$accept ? '#16a34a' : '#3f3f46')};
  &:hover { filter: brightness(1.1); }
`;

/** Ringing card for an inbound call to the shared number. */
const IncomingCallBanner = ({ incomingCall, onAccept, onDismiss }) => {
  if (!incomingCall) return null;
  const { callerName, from } = incomingCall;

  return ReactDOM.createPortal(
    <Card role="alertdialog" aria-label="Incoming call">
      <Top>
        <Ring><FontAwesomeIcon icon={faPhone} /></Ring>
        <div style={{ minWidth: 0 }}>
          <Label>Incoming call</Label>
          <Name>{callerName || formatPhone(from)}</Name>
          {callerName && <CallerNumber>{formatPhone(from)}</CallerNumber>}
        </div>
      </Top>
      <Actions>
        <ActionButton type="button" onClick={onDismiss}>
          <FontAwesomeIcon icon={faPhoneSlash} /> Dismiss
        </ActionButton>
        <ActionButton type="button" $accept onClick={onAccept}>
          <FontAwesomeIcon icon={faPhone} /> Answer
        </ActionButton>
      </Actions>
    </Card>,
    document.body
  );
};

export default IncomingCallBanner;
